import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import constants from "../../constants";
import http from "../http";
var GRADE_CATEGORY_ENDPOINT = "".concat(constants.API_URL, "/grade-categories");

function updateGradeCategory(_x, _x2) {
  return _updateGradeCategory.apply(this, arguments);
}

function _updateGradeCategory() {
  _updateGradeCategory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(itemId, data) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return http.patch("".concat(GRADE_CATEGORY_ENDPOINT, "/").concat(itemId), data);

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _updateGradeCategory.apply(this, arguments);
}

function deleteGradeCategory(_x3) {
  return _deleteGradeCategory.apply(this, arguments);
}

function _deleteGradeCategory() {
  _deleteGradeCategory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(itemId) {
    var response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return http["delete"]("".concat(GRADE_CATEGORY_ENDPOINT, "/").concat(itemId));

          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _deleteGradeCategory.apply(this, arguments);
}

export default {
  updateGradeCategory: updateGradeCategory,
  deleteGradeCategory: deleteGradeCategory
};